import { removeElement } from '@/uikit/notification/helpers/element';

export class NotificationManager {
    getNotification(nodeId: string): HTMLElement | null {
        return document.getElementById(nodeId);
    }

    removeNotification(node: HTMLElement): void {
        removeElement(node);
    }
}

export const notificationManager = new NotificationManager();